import React from 'react';
import Paper from 'material-ui/Paper';

export default props => (
  <Paper 
    zDepth={1}
    {...props}
  />
);